export default {
  namespaced: true,
  state: {
    elderly: [], // 长者数据
    currentElderly: {}
  },
  mutations: {
    SET_ELDERLY (state, value) {
      state.elderly = value
    },
    SET_CURRENT_ELDERLY (state, value) {
      state.currentElderly = value
    },
  },
  actions: {
    setElderly ({ commit }, value) {
      commit('SET_ELDERLY', value)
    },
    setCurrentElderly ({ commit }, value) {
      commit('SET_CURRENT_ELDERLY', value)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/family.js